import React from 'react';

/** A replacement component: what the page should hold in place of the one being edited. */
export type ReplacementComponent = { widgetId: string; props: Record<string, unknown>; subcomponents: unknown[] };

/**
 * Lets a property editor inside the edit modal swap the whole component (e.g.
 * an AI widget for the custom widget made from it). Only the page editor
 * provides `replace`; elsewhere (widget presets) it is null.
 */
// `compact`: the editors render in the inspector column instead of the edit window.
// `componentId`: the section being edited (an editor-session id until the draft is saved).
const EditComponentContext = React.createContext<{ replace: ((component: ReplacementComponent) => void) | null; compact?: boolean; componentId?: string | null }>({ replace: null });

export default EditComponentContext;
